import { FC } from 'react';

import { SvgIcon, SxProps, useTheme } from '@thirdspacelearning/library';

interface Props {
    sx?: SxProps;
}

const LoIncompleteIcon: FC<Props> = ({ sx }) => {
    const theme = useTheme();

    return (
        <SvgIcon
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={sx}
            data-testid="learning-objective-incomplete-icon"
        >
            <circle cx="40" cy="40" r="40" fill={theme.palette.info.light} />
            <circle cx="40" cy="40" r="28" fill={theme.palette.info.main} />
            <circle cx="40" cy="40" r="22" fill={theme.palette.info.light} />
        </SvgIcon>
    );
};

export default LoIncompleteIcon;
